module.exports = __webpack_public_path__ + "media/assets/images/icons/profile-generic/avatar-example-3-f8c6302038ee4ec5c0fbe3dc54c5bb10.png";